import React from 'react';
import styled from 'styled-components';

const StyledBadge = styled.span`
    font-size: 12px;
    padding: 6px 12px;
    border-radius: 16px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    
    &.badge-warning {
        background: #FFF1CC;
        color: #AF8A2A;
        border: 1px solid #FFDA7A;
    }
    
    &.badge-draft {
        background: rgba(58, 44, 81, 0.1);
        color: #555555;
        border: 1px solid rgba(58, 44, 81, 0.3);
    }
    
    &.badge-primary {
        background: #E7EFF6;
        color: #135CA9;
        border: 1px solid #A2C4DE;
    }
    
    &.badge-success {
        background: #DEF5F2;
        color: #06872A;
        border: 1px solid #C7EACB;
    }
    
    &.badge-danger {
        background: #F2E0E2;
        color: #A7343D;
        border: 1px solid #D39A9E;
    }
    
    i {
        font-size: 14px;
    }
`;

const STATUS_MAP = {
    'Processing': {
        label: 'В обработке',
        className: 'badge-warning',
        icon: 'fa-sun'
    },
    'Completed': {
        label: 'Обработан',
        className: 'badge-draft',
        icon: 'fa-check'
    },
    'Calculated': {
        label: 'Рассчитан',
        className: 'badge-success',
        icon: 'fa-calculator'
    },
    'ParcelsCreated': {
        label: 'Накладные созданы',
        className: 'badge-primary',
        icon: 'fa-check'
    },
    'Ordered': {
        label: 'Заказано',
        className: 'badge-success',
        icon: 'fa-truck'
    },
    'Error': {
        label: 'Ошибка',
        className: 'badge-danger',
        icon: 'fa-exclamation-triangle'
    }
};

const StatusBadge = ({status, parseErrors}) => {
    const statusInfo = STATUS_MAP[status] || {
        label: status,
        className: 'badge-default',
        icon: 'fa-question'
    };

    const title = status === 'Error' && parseErrors
        ? parseErrors
        : undefined;

    return (
        <StyledBadge className={statusInfo.className} title={title}>
            <i className={`fa ${statusInfo.icon}`}></i>
            {statusInfo.label}
        </StyledBadge>
    );
};

export default StatusBadge;



// WEBPACK FOOTER //
// ./App/pages/massUpload/components/StatusBadge.jsx